
define('text!common/views/commercial/creatives/manual-card-cta.html',[],function () { return '<span class="advert__more button button--small <%=classNames%>">\n    <%=offerLinkText%> <%=arrowRight%>\n</span>\n';});

